import { c as _c } from "react/compiler-runtime";
import classNames from "classnames";

/**
 * Base shimmer block for building page/component skeletons.
 * Pass width/height (and optionally rounded) to shape it, then compose
 * multiple instances inside your own flex/grid divs to match a layout.
 * Uses the existing `animate-shimmer` keyframe (tailwind.config.js) — a
 * left-to-right gradient sweep over the neutral design-token grays, same
 * technique as the gallery loading skeleton.
 *
 * Pass `width`/`height` as `null` to skip that inline dimension entirely
 * (e.g. when a responsive Tailwind height class like `md:h-[560px]` needs
 * to control it instead — inline styles would otherwise override it at
 * every breakpoint).
 */
export default function Skeleton(t0) {
  const $ = _c(22);
  let props;
  let style;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      width: t1,
      height: t2,
      rounded: t3,
      className: t4,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = style;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    props = $[1];
    style = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  const width = t1 === undefined ? "100%" : t1;
  const height = t2 === undefined ? "1rem" : t2;
  const rounded = t3 === undefined ? "rounded-md" : t3;
  const className = t4 === undefined ? "" : t4;
  let t5;
  if ($[7] !== className || $[8] !== rounded) {
    t5 = classNames("animate-shimmer", rounded, className);
    $[7] = className;
    $[8] = rounded;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== width) {
    t6 = width !== null && {
      width
    };
    $[10] = width;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== height) {
    t7 = height !== null && {
      height
    };
    $[12] = height;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== style || $[15] !== t6 || $[16] !== t7) {
    t8 = {
      ...t6,
      ...t7,
      backgroundImage: "linear-gradient(90deg, var(--primitivesNeutralNeutral90, #e4e3db) 25%, var(--primitivesNeutralNeutral80, #c8c7bf) 37%, var(--primitivesNeutralNeutral90, #e4e3db) 63%)",
      backgroundSize: "400% 100%",
      ...style
    };
    $[14] = style;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== props || $[19] !== t5 || $[20] !== t8) {
    t9 = <div aria-hidden="true" className={t5} style={t8} {...props} />;
    $[18] = props;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}